// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6781) return "static/chunks/6781.5c600218a3bf98f7.js";
	if (chunkId === 6884) return "static/chunks/6884.3cd45c79e62e9687.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2124":"9ddd8772e28add79","3587":"06c87c0a4455dc02","5147":"f68b929a5c86c6ed","8633":"f23f813fb99adccc"}[chunkId] + ".js";
};